import React from "react";

import ImageCard from "../../components/ImageCard/ImageCard";

import Banner from "../../sections/Banner/Banner";
import ContentBlock from "../../sections/ContentBlock/ContentBlock";
// import Button from "../../components/Button/Button";

const news = () => {
  return (
    <div className="News">
      <Banner
        img_src="https://districttrack.s3.us-east-2.amazonaws.com/assets/media/DTC/team.jpg"
        img_alt="Our Team"
      >
        <h1>News</h1>
      </Banner>
      <section>
        <ContentBlock>
          <ImageCard
            img_src="https://districttrack.s3.us-east-2.amazonaws.com/v2/photos/running/edose-2.JPG"
            img_alt="Edose Running"
            to="/"
            buttonText="Listen Here"
          >
            <h3>Citius Mag</h3>
            <h4>July 30, 2020</h4>
          </ImageCard>
          <ImageCard
            img_src="https://districttrack.s3.us-east-2.amazonaws.com/v2/photos/running/edose-3.JPG"
            img_alt="Edose Smiling"
            to="/"
            buttonText="Listen Here"
          >
            <h3>Run Your Mouth</h3>
            <h4>October 30, 2020</h4>
          </ImageCard>
          <ImageCard
            img_src="https://districttrack.s3.us-east-2.amazonaws.com/v2/photos/running/edose-1.jpg"
            img_alt="Edose Smiling"
            to="/"
            buttonText="Read Here"
          >
            <h3>Runners World</h3>
            <h4>September 22, 2020</h4>
          </ImageCard>
        </ContentBlock>
      </section>
    </div>
  );
};

export default news;
